import { FC }              from 'react';
import Style               from './TimePicker.style';
import dayjs               from 'dayjs';
import { DatePickerProps } from 'antd';

type TProps = {
  value?: number,
  format?: string,
  defaultValue?: number,
  onChange?: (value: string | null) => void,
  picker?: 'date' | 'month' | 'year',
}

export const TimePicker: FC<TProps> = ({ value, format = 'HH:mm', defaultValue, onChange, ...props }) => {

  const handleOnChange: DatePickerProps['onChange'] = (value, timeString) => {
    if (onChange && typeof onChange === 'function') {
      if (!value) {
        return onChange(null);
      }
      onChange(timeString as string);
    }
  };

  const val = value || defaultValue;

  return (
    <Style
      {...props}
      format={format}
      value={val ? dayjs(val) : null}
      /* @ts-ignore */
      onChange={handleOnChange}
      needConfirm={false}
    />
  );
};
